import React, { useEffect, lazy, Suspense, useMemo } from 'react';
import { useSiteContent } from '@/lib/useSiteContent';
import HomeIntro from '@/components/HomeIntro';
import CollectionPreview from '@/components/CollectionPreview';
import ChristmasBanner from '@/components/ChristmasBanner';

const JerseyOfTheWeek = lazy(() => import('@/components/JerseyOfTheWeek'));

const VisitTeaser = lazy(() => import('@/components/VisitTeaser'));
const SellCta = lazy(() => import('@/components/SellCta'));
const DailyQuiz = lazy(() => import('@/components/DailyQuiz'));
const HeroNewsletter = lazy(() => import('@/components/HeroNewsletter'));

export default function Home() {
  const { content } = useSiteContent();
  const h = content.hero;
  const tickerItems = useMemo(() => content.ticker?.items || [], [content.ticker]);



  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open') !== 'treyjuthraut') return;
    let attempts = 0;
    const timer = setInterval(() => {
      const el = document.getElementById('spurning-dagsins');
      attempts++;
      if (el) {
        clearInterval(timer);
        let stableCount = 0;
        const scrollInterval = setInterval(() => {
          el.scrollIntoView({ behavior: 'smooth' });
          const rect = el.getBoundingClientRect();
          if (Math.abs(rect.top) < 5) {
            stableCount++;
          } else {
            stableCount = 0;
          }
          if (stableCount >= 3) {
            clearInterval(scrollInterval);
          }
        }, 400);
        setTimeout(() => clearInterval(scrollInterval), 4000);
      } else if (attempts >= 100) {
        clearInterval(timer);
      }
    }, 100);
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <HomeIntro title={h.title} tickerItems={tickerItems} onOpenQuiz={() => document.getElementById('spurning-dagsins')?.scrollIntoView({ behavior: 'smooth' })} />
      <ChristmasBanner />
      <CollectionPreview />
      <Suspense fallback={<div className="min-h-[700px] md:min-h-[600px]" aria-hidden="true" />}><JerseyOfTheWeek /></Suspense>
      <Suspense fallback={<div className="min-h-[600px]" aria-hidden="true" />}><SellCta /></Suspense>
      <Suspense fallback={<div className="min-h-[400px]" aria-hidden="true" />}><HeroNewsletter /></Suspense>
      <Suspense fallback={<div className="min-h-[500px]" aria-hidden="true" />}><DailyQuiz /></Suspense>
      <Suspense fallback={<div className="min-h-[200px]" aria-hidden="true" />}><VisitTeaser /></Suspense>
    </div>
  );
}